// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyStateUI_emptyState__NIQaw"};